function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var r = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty,
    w = Object.prototype.propertyIsEnumerable;

var L = function L(C, t, o) {
  return t in C ? r(C, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : C[t] = o;
},
    e = function e(C, t) {
  for (var o in t || (t = {})) {
    l.call(t, o) && L(C, o, t[o]);
  }

  if (n) {
    var _iterator = _createForOfIteratorHelper(n(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        w.call(t, o) && L(C, o, t[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return C;
};

import * as i from "react";

function h(C) {
  return i.createElement("svg", e({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, C), i.createElement("path", {
    d: "M19.9673 4.21193C19.4793 3.72387 18.6909 3.72387 18.2028 4.21193L12.0834 10.3189L5.96392 4.19941C5.47587 3.71136 4.68747 3.71136 4.19941 4.19941C3.71136 4.68747 3.71136 5.47587 4.19941 5.96392L10.3189 12.0834L4.19941 18.2028C3.71136 18.6909 3.71136 19.4793 4.19941 19.9673C4.68747 20.4554 5.47587 20.4554 5.96392 19.9673L12.0834 13.8479L18.2028 19.9673C18.6909 20.4554 19.4793 20.4554 19.9673 19.9673C20.4554 19.4793 20.4554 18.6909 19.9673 18.2028L13.8479 12.0834L19.9673 5.96392C20.4429 5.48838 20.4429 4.68747 19.9673 4.21193Z",
    fill: "black"
  }));
}

export { h as ReactComponent };